export const down = {
    namespaced: true,   
    state: {        
        downFailedArray: [],
    },
    actions: {
        setDownFailedArray({ commit }, file) {
            commit('addDownFailedArray', file)
        },
        setCleanDownFailedArray({ commit }) {
            commit('cleanDownFailedArray')
        },
    },
    mutations: {
        addDownFailedArray(state, file) {
            state.downFailedArray.push(file);
        },
        cleanDownFailedArray(state) {
            state.downFailedArray.length = 0;
        },
    }
};